import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const CrossIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 16,
  height = 16,
  customColour,
  iconRef,
  ...rest
}) => {
  const className = customColour ? '' : 'interactiveColor'

  return (
    <Icon
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      iconRef={iconRef}
      {...rest}
    >
      <path
        d="M13.5,8.8817842e-16 C13.5,8.8817842e-16 14,0.5 15,1.5 L9,7.5 L15,13.5 L13.5,15 L7.5,9 L1.5,15 L0,13.5 L6,7.5 L0,1.5 L1.5,8.8817842e-16 L7.5,6 C11.5,2 13.5,8.8817842e-16 13.5,8.8817842e-16 Z"
        data-testid="icon-cross"
        fill={customColour}
        className={styles[className]}
      />
    </Icon>
  )
}
